import React, { useState } from "react";
import { RevealHeading } from "./Motion";
import { BnGlyph } from "./Decorations";

const FAQS = [
    {
        q: "How natural does the Bengali audio actually sound?",
        a: "We trained on 800+ hours of Bengali broadcast audio across BD and West Bengal dialects. Most listeners can't tell it's AI on first listen. We update the voice models every quarter based on listener feedback.",
    },
    {
        q: "What's the catch with the free tier?",
        a: "Honestly, there isn't one. 20 articles per month, standard voice, Audo attribution at the end of each play. No credit card. We expect maybe 10% will upgrade — that's enough.",
    },
    {
        q: "Who owns the generated audio?",
        a: "You do. The audio is yours forever, even if you cancel. We don't sell it. We don't reuse it. We don't train on your text. It's in our terms in clear English (and Bengali).",
    },
    {
        q: "Can I get a custom voice — like our anchor's actual voice?",
        a: "Yes, on Business and Enterprise plans. We need ~30 minutes of clean studio recording, signed consent, and 2 weeks. Voice rights stay with the original speaker.",
    },
    {
        q: "Does this work for West Bengal publishers too?",
        a: "Yes. We have a separate dialect model for Kolkata Bengali (different vowel placement, different code-mixing patterns). Pricing in INR coming Q2 2026.",
    },
    {
        q: "How does the WordPress plugin install?",
        a: "Search 'Audo' in your plugin directory. Activate. Paste your API key. Done — every new post auto-generates audio. Older posts can be batch-converted from the dashboard.",
    },
    {
        q: "Tell me more about the 70/30 ad revenue share.",
        a: "We sell pre-roll and mid-roll audio ads programmatically. You keep 70% of net revenue, we keep 30%. Payouts monthly via bKash, Nagad, or international wire. Minimum 5K monthly plays to qualify.",
    },
    {
        q: "Where is my data stored? Is it private?",
        a: "Audio files on AWS Mumbai (closest to Dhaka). Article text is processed and discarded — we don't keep it. SOC 2 Type II audit completed. GDPR + Bangladesh DPA aligned.",
    },
];

const Item = ({ q, a, open, onToggle, idx }) => (
    <div data-testid={`faq-item-${idx}`} className="border-b border-cream-300 last:border-b-0">
        <button
            onClick={onToggle}
            className="w-full flex items-center justify-between text-left py-7 lg:py-8 group"
            aria-expanded={open}
        >
            <h3 className="font-display text-[22px] sm:text-[28px] lg:text-[34px] font-semibold tracking-tight text-ink leading-snug pr-6 group-hover:text-coral transition-colors">
                {q}
            </h3>
            <span className={`relative w-9 h-9 lg:w-11 lg:h-11 rounded-full bg-cream-100 border border-cream-300 flex-shrink-0 flex items-center justify-center transition-all duration-300 ${open ? "bg-coral border-coral rotate-180" : "group-hover:bg-ink group-hover:border-ink"}`}>
                <span className={`absolute w-3.5 lg:w-4 h-[2.5px] rounded-full transition-colors ${open ? "bg-white" : "bg-ink group-hover:bg-cream-100"}`}/>
                <span className={`absolute w-[2.5px] lg:h-4 h-3.5 rounded-full transition-all duration-300 ${open ? "bg-white scale-y-0" : "bg-ink group-hover:bg-cream-100"}`}/>
            </span>
        </button>
        <div
            className="grid transition-all duration-500 ease-out"
            style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
        >
            <div className="overflow-hidden">
                <p className="pb-7 lg:pb-9 pr-12 text-[15px] sm:text-[17px] text-ink-muted leading-relaxed max-w-[820px]">
                    {a}
                </p>
            </div>
        </div>
    </div>
);

export const FAQ = () => {
    const [openIdx, setOpenIdx] = useState(0);
    return (
        <section id="faq" className="relative py-24 lg:py-32 overflow-hidden">
            <BnGlyph glyph="?" className="absolute -left-2 top-10 text-[200px] lg:text-[320px] leading-none font-bold opacity-[0.04] select-none" color="#0A0A0A"/>
            <div className="relative mx-auto max-w-[1100px] px-5 sm:px-8">
                <div className="mb-10 lg:mb-14 max-w-[820px]">
                    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">Questions, answered</p>
                    <RevealHeading as="h2" className="h-display text-[44px] sm:text-[64px] lg:text-[88px] text-ink">
                        The honest <span className="italic-display text-coral">FAQ.</span>
                    </RevealHeading>
                </div>
                <div className="bg-white rounded-[32px] border border-cream-300 shadow-soft px-6 sm:px-10 lg:px-12">
                    {FAQS.map((f, i) => (
                        <Item key={i} idx={i} q={f.q} a={f.a} open={openIdx === i} onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}/>
                    ))}
                </div>
            </div>
        </section>
    );
};
